import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import global from './modules/global'
import menu from './modules/menu'
import userAuth from './modules/user-auth'
import userPinAuth from './modules/user-pin-auth'
import dashboard from './modules/dashboard'
import calendar from './modules/calendar'
import shifts from './modules/shifts'
import timeclock from './modules/timeclock'
import tasks from './modules/tasks'
import employees from './modules/employees'
import skills from './modules/skills'
import promotions from './modules/promotions'
import colorCategories from './modules/color-categories'
import teams from './modules/teams'
import hr from './modules/hr'
import resources from './modules/resources'
import uploader from './modules/uploader'
import messages from './modules/messages'
import serviceRequest from './modules/service-request'
import clients from './modules/clients'
import clientBusinesses from './modules/clientBusinesses'
import reports from './modules/reports'
import profiles from './modules/profiles'
import holidays from './modules/holidays'
import geotags from './modules/geotags'
import worksites from './modules/worksites'
import bulletinBoard from './modules/bulletin-board'
import managers from './modules/managers'
import coordinatedCoverageRequests from './modules/coordinated-coverage-requests'
import shiftReviews from './modules/shift-reviews'
import referrers from './modules/referrers'
import todos from './modules/todos'

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    global,
    menu,
    userAuth,
    userPinAuth,
    dashboard,
    calendar,
    shifts,
    timeclock,
    tasks,
    employees,
    skills,
    promotions,
    colorCategories,
    teams,
    hr,
    resources,
    uploader,
    messages,
    serviceRequest,
    clients,
    clientBusinesses,
    reports,
    profiles,
    holidays,
    geotags,
    worksites,
    bulletinBoard,
    managers,
    coordinatedCoverageRequests,
    shiftReviews,
    referrers,
    todos,
  },
  strict: debug,
})

